import type { ApiListRequest, ApiListResponseV3 } from "../@types/services/Api";
import type {
  MaterialGroup,
  MaterialGroupsFilter,
} from "../@types/services/MaterialGroup";
import { api } from "./api";

const API_BASE_URL = "/api/v3/material_groups";

export const fetchMaterialGroup = async (
  id: MaterialGroup["id"],
): Promise<MaterialGroup> => {
  const response = await api.get<MaterialGroup>(`/${id}`, {
    baseURL: API_BASE_URL,
  });
  return response.data;
};

export const fetchMaterialGroups = async ({
  filters,
  ...rest
}: ApiListRequest<MaterialGroupsFilter> = {}): Promise<
  ApiListResponseV3<MaterialGroup>
> => {
  const response = await api.get<ApiListResponseV3<MaterialGroup>>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });
  return response.data;
};
